import { guessDnsRecordName } from '@gl/shared';
import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { copyToClipboard } from './useCopy';

function Row({ label, value, copy }: { label: string; value: string; copy?: boolean }) {
  return (
    <div className="grid grid-cols-[5rem_minmax(0,1fr)] items-center gap-3 border-b py-1.5 last:border-b-0">
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="flex min-h-7 min-w-0 items-center gap-1 font-mono text-sm">
        <span className="truncate">{value}</span>
        {copy && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="size-7"
            aria-label={`Copiar ${label.toLowerCase()}`}
            onClick={() => void copyToClipboard(value, `${label} copiado`)}
          >
            <Copy className="size-3.5" />
          </Button>
        )}
      </dd>
    </div>
  );
}

/** Pasos para crear el CNAME en el proveedor DNS del local. */
export function DnsInstructions({ hostname, cnameTarget }: { hostname: string; cnameTarget: string }) {
  const { name, zone } = guessDnsRecordName(hostname);

  return (
    <div className="grid gap-3 rounded-lg border bg-muted/40 p-4 text-sm">
      <p className="font-medium">Cómo conectar {hostname}</p>
      <ol className="grid list-decimal gap-3 pl-5">
        <li>Entrá al panel DNS de tu dominio ({zone}).</li>
        <li>
          Creá este registro:
          <dl className="mt-2 max-w-md rounded-md border bg-background px-3">
            <Row label="Tipo" value="CNAME" />
            <Row label="Nombre" value={name} copy />
            <Row label="Destino" value={cnameTarget} copy />
            <Row label="TTL" value="Auto" />
          </dl>
          <p className="mt-2 text-xs text-muted-foreground">
            Queda {hostname}. Si tu proveedor pide el nombre completo, poné {hostname}.
          </p>
          <p className="mt-1 text-xs text-muted-foreground">
            Si usás Cloudflare, dejá &quot;DNS only&quot; (nube gris). Con nube naranja también funciona.
          </p>
        </li>
        <li>Guardá y tocá &quot;Verificar&quot;. Puede tardar de 2 minutos a 1 hora.</li>
      </ol>
      <p className="text-xs text-muted-foreground">No se puede usar el dominio pelado: tiene que ser un subdominio.</p>
    </div>
  );
}
